/**
 * Created by Daniela on 29/11/2016.
 */
export class Seguradora {
  ativo: boolean;
  id: number;
  pessoaJuridicaId: number;
  situacaoId: number;
  nome: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/shared/seguradora.model.ts
 **/